<template>
  <div class="score-bar-container">
    <span class="pointer" :style="leftStyle">{{ score }}</span>
    <span></span>
    <p>
      <span v-for="item in scaleArr" :key="item">
        {{ item }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'score-bar.vue',
  data() {
    return {
      a: 1,
    }
  },
  computed: {
    leftStyle() {
      if (this.score === 0) {
        return `left: -1%`
      }
      return `left: ${Math.floor(
        (this.score / this.scaleArr[this.scaleArr.length - 1]) * 100 - 2,
      )}%`
    },
  },
  props: {
    scaleArr: {
      type: Array,
      default: () => [],
    },
    score: {
      type: Number,
      default: () => 0,
    },
  },
}
</script>

<style scoped lang="scss">
.score-bar-container {
  width: 100%;
  height: 100%;
  position: relative;
  .pointer {
    position: relative;
    display: inline-block;
    font-size: 12px;
    bottom: 10px;
    width: 16px;
    text-align: center;
    &::after {
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      top: 12px;
      left: 0;
      border-top: 8px solid #409eff;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
  }
  & > span:nth-child(2) {
    display: inline-block;
    width: 100%;
    height: 30px;
    background-image: linear-gradient(
      269deg,
      #00ca42 1%,
      #ffdc00 71%,
      #d00000 100%
    );
    border-radius: 2px;
  }
  & > p:nth-child(3) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    span {
      display: inline-block;
      position: relative;
      //&:before {
      //  content: '';
      //  display: inline-block;
      //  width: 2px;
      //  height: 5px;
      //  background-color: #303133;
      //  position: absolute;
      //  top: -6px;
      //  left: 0;
      //}
    }
    span:first-child {
      //&:before {
      //  left: 0;
      //}
    }
    span:last-child {
      //&:before {
      //  left: 94%;
      //}
    }
  }
}
</style>
